exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LoginPanel__root___3K6IN {\n  max-width: 450px;\n}\n.LoginPanel__logo___2tmKT {\n  width: 30px;\n  margin-right: 0.5rem;\n  margin-bottom: 0.2rem;\n}\n", ""]);
// Exports
exports.locals = {
	"root": "LoginPanel__root___3K6IN",
	"logo": "LoginPanel__logo___2tmKT"
};